import _ from 'lodash';

function HealthDetailCtrl($scope, $rootScope, $state, $stateParams, $q, $timeout, $ngConfirm, toastr, AuthService, AppContextService, BioService, UserService, DashboardService, PlanService) {
  'ngInject';

  const vm = this;
  vm.appContext = AppContextService.context;

  if ($stateParams.tab) {
    vm.tab = $stateParams.tab;
  } else {
    vm.tab = 'daily';
  }

  vm.showDetail = false; // 선수 데이터 입력창 모드
  vm.playersBioInfo = [];
  vm.inputBioInfo = null;
  vm.selectPlayer = null;
  vm.date = moment().format("YYYY.MM.DD");

  var dailyItems = ['bodyheat', 'height'],
    dailySuffixes = ['_target', ''];
  var deviceItems = ['DS', 'VL', 'SP', 'AC', 'HB', 'OS', 'LA', 'BT2'],
    deviceSuffixes = ['_max', '', '_distance', '_hour'];

  var dataList = function (fromDate, toDate) {
    var params = {
      'login_id': vm.appContext.user.login_id,
      'uuid': vm.appContext.user.uuid,
      'date': toDate || moment().format("YYYY.MM.DD"),
      'from_date': fromDate || '2000.01.01'
    };
    BioService.healthDataList(params).then(function (res) {
      console.log(res.data)
      // var history = res.data.data[1].history[0].records[0].date;

      var find = _.find(res.data.data, {
        user_id: Number($stateParams.user_id)
      })
      console.log('find', find);

      var bios = [];
      for (var j = 0; j < find.history.length; j++) {
        for (var k = 0; k < find.history[j].records.length; k++) {
          // console.log('type', find.history[j].type);
          var obj = _.find(bios, {
            date: find.history[j].records[k].date
          });
          if (!obj) {
            // bios.push({ date: find.history[j].records[k].date, find.history[j].type : find.history[j].records[k].value });
            bios.push({
              date: find.history[j].records[k].date
            });
          }
        }
      }
      // console.log('bios', bios);
      bios = _.orderBy(bios, ['date'], ['desc']); // Use Lodash to sort array by 'name'
      // console.log('sort', bios);


      for (var j = 0; j < find.history.length; j++) {
        for (var k = 0; k < find.history[j].records.length; k++) {
          // console.log('type', find.history[j].type);
          var obj2 = _.find(bios, {
            date: find.history[j].records[k].date
          });
          // console.log('obj2', obj2)
          //obj2[find.history[j].type] = find.history[j].records[k].value;
        }
      }

      _.forEach(bios, function(item2) {
        BioService.userData2({user_id: $stateParams.user_id, day:(item2.date.replace(/\./g, ''))}).then(function(res2) {
          _.forEach(res2.data.list, function(item) {
            var value,
              values = [];

            if (item.type === 'CB' || item.type === 'CL') {
              values.push(item.current_1);
            } else {
              values.push(item.current);
              item2[item.type + '1'] = item.current;
              if (typeof item.current2 !== 'undefined') {
                values.push(item.current2);
                item2[item.type + '2'] = item.current2;
              }
              if (typeof item.current3 !== 'undefined') {
                values.push(item.current3);
                item2[item.type + '3'] = item.current3;
              }
              if (typeof item.current4 !== 'undefined') {
                values.push(item.current4);
                item2[item.type + '4'] = item.current4;
              }
              if (typeof item.current5 !== 'undefined') {
                values.push(item.current5);
                item2[item.type + '5'] = item.current5;
              }
              if (typeof item.current6 !== 'undefined') {
                values.push(item.current6);
                item2[item.type + '6'] = item.current6;
              }
            }
            
            value = values.join(',');

            item2[item.type] = value;
          });
        }).catch(function(err) {
          console.log(err);
        });

        // // 디바이스 데이터
        // BioService.deviceData({user_id: $stateParams.user_id, day:item2.date, type:'DS'}).then(function(res2) {
        //   console.log('device data', res2.data);
        // }).catch(function(err) {
        //   console.log(err);
        // });
      });

      // console.log('binding', bios);
      vm.playersBioInfo = bios;

      var obj = _.find(vm.playersBioInfo, {
        date: vm.bio.day
      });
      if (obj) {
        vm.bio = _.merge({}, vm.bio, obj);
        console.log(vm.bio);
      }

      _.forEach(vm.playersBioInfo, function(bio) {
        _.forEach(dailyItems, function(item) {
          _.forEach(dailySuffixes, function(suffix) {
            var type = item + suffix;

            // 데일리 데이터 조회
            $.ajax({
              url: 'http://eptsdev.codns.com:7724/manager/get_daily_data',
              type: 'GET',
              data: {
                user_id: $stateParams.user_id,
                day: bio.date,
                type: type
              },
              success: function(data) {
                if (data.length) {
                  var dataItem = data[0];

                  var obj = _.find(vm.playersBioInfo, {
                    date: dataItem.day
                  });

                  if (obj) {
                    obj[dataItem.type] = dataItem.value;
                  }
                }
              },
              error: function(err) {
                console.log(err);
              }
            });
          });
        });
      });

      _.forEach(vm.playersBioInfo, function(bio) {
        _.forEach(deviceItems, function(item) {
          _.forEach(deviceSuffixes, function(suffix) {
            var type = item + suffix;

            // 디바이스 데이터 조회
            $.ajax({
              url: 'http://eptsdev.codns.com:7724/manager/get_device_data',
              type: 'GET',
              data: {
                user_id: $stateParams.user_id,
                day: bio.date,
                type: type
              },
              success: function(data) {
                if (data.length) {
                  var dataItem = data[0];

                  var obj = _.find(vm.playersBioInfo, {
                    date: dataItem.day
                  });

                  if (obj) {
                    obj[dataItem.type] = dataItem.value;
                  }
                }
              },
              error: function(err) {
                console.log(err);
              }
            });
          });
        });
      });
    });
  }
  dataList();

  vm.getPlayerBiometricInfo = dataList;



  var getPlayerBio = function (day) {
    var params = {
      'user_id': $stateParams.user_id,
    };
    if (day) {
      params.day = day;
    }
    BioService.userDataAll(params).then(function (res) {console.log('bio', res.data);
      vm.bio = res.data;

      _.forEach(dailyItems, function(item) {
        _.forEach(dailySuffixes, function(suffix) {
          var type = item + suffix;

          // 데일리 데이터 조회
          $.ajax({
            url: 'http://eptsdev.codns.com:7724/manager/get_daily_data',
            type: 'GET',
            data: {
              user_id: $stateParams.user_id,
              day: params.day,
              type: type
            },
            success: function(data) {
              if (data.length) {
                var dataItem = data[0];
                vm.bio[dataItem.type] = dataItem.value;
              }
            },
            error: function(err) {
              console.log(err);
            }
          });
        });
      });
      
      _.forEach(deviceItems, function(item) {
        _.forEach(deviceSuffixes, function(suffix) {
          var type = item + suffix;

          // 디바이스 데이터 조회
          $.ajax({
            url: 'http://eptsdev.codns.com:7724/manager/get_device_data',
            type: 'GET',
            data: {
              user_id: $stateParams.user_id,
              day: params.day,
              type: type
            },
            success: function(data) {
              if (data.length) {
                var dataItem = data[0];
                vm.bio[dataItem.type] = dataItem.value;
              }
            },
            error: function(err) {
              console.log(err);
            }
          });
        });
      });

      var obj = _.find(vm.playersBioInfo, {
        date: vm.bio.day
      });
      if (obj) {
        vm.bio = _.merge({}, vm.bio, obj);
        console.log(vm.bio);
      }
    }).catch(function (e) {
      console.log('ERROR ' + e);
    });

  }
  getPlayerBio();

  var userInfo = function () {
    var data = {
      'user_id': $stateParams.user_id,
    }
    UserService.info(data).then(function (res) {
      // console.log(res.data);
      vm.info = res.data;
    }).catch(function (e) {
      console.log('ERROR ' + e);
    });

  }
  userInfo();



  vm.saveDaily = function () {

    $q.all([
      BioService.userInput({
        user_id: $stateParams.user_id,
        day: vm.date,
        type: 'BW',
        value: vm.bio.weight
      }),
      BioService.setTarget({
        user_id: $stateParams.user_id,
        day: vm.date,
        type: 'BW',
        value: vm.bio.weight_target
      }),

      BioService.userInput({
        user_id: $stateParams.user_id,
        day: vm.date,
        type: 'CB',
        order: 1,
        value: vm.bio.calrorie_burned
      }),
      BioService.setTarget({
        user_id: $stateParams.user_id,
        day: vm.date,
        type: 'CB',
        value: vm.bio.calrorie_burned_target
      }),

      BioService.userInput({
        user_id: $stateParams.user_id,
        day: vm.date,
        type: 'CL',
        order: 1,
        value: vm.bio.calrorie_get
      }),
      BioService.setTarget({
        user_id: $stateParams.user_id,
        day: vm.date,
        type: 'CL',
        value: vm.bio.calrorie_target
      }),

      BioService.userInput({
        user_id: $stateParams.user_id,
        day: vm.date,
        type: 'WT',
        value: vm.bio.water_get
      }),
      BioService.setTarget({
        user_id: $stateParams.user_id,
        day: vm.date,
        type: 'WT',
        value: vm.bio.water_target
      }),

      BioService.userInput({
        user_id: $stateParams.user_id,
        day: vm.date,
        type: 'ST',
        value: vm.bio.sleep_time
      }),
      BioService.setTarget({
        user_id: $stateParams.user_id,
        day: vm.date,
        type: 'ST',
        value: vm.bio.sleep_target
      }),




    ]).then(function (results) {
      toastr.success('저장되었습니다.')
      dataList();
    }, function () {
      toastr.error('ERROR ')
      dataList();
    }).catch(function (e) {
      console.log('ERROR ' + e);
    });

    _.forEach(dailyItems, function(item) {
      _.forEach(dailySuffixes, function(suffix) {
        var type = item + suffix;

        // 데일리 데이터 저장
        $.ajax({
          url: 'http://eptsdev.codns.com:7724/manager/save_daily_data',
          type: 'POST',
          data: {
            user_id: $stateParams.user_id,
            day: vm.date,
            type: type,
            value: vm.bio[type]
          },
          success: function(data) {
            console.log(data);
          },
          error: function(err) {
            console.log(err);
          }
        });
      });
    });

  }

  vm.saveDevice = function () {

    $q.all([
      // BioService.userInput({
      //   user_id: $stateParams.user_id,
      //   day: vm.date,
      //   type: 'BW',
      //   value: vm.bio.weight
      // }),
      // BioService.setTarget({
      //   user_id: $stateParams.user_id,
      //   day: vm.date,
      //   type: 'BW',
      //   value: vm.bio.weight_target
      // }),

      //         var deviceInputParams = {
      //   'user_id': vm.selectPlayer.user_id,
      //   type: type
      // };

      // deviceInputParams['value'] = vm.selectBioData.DS;
      // deviceInputParams['stable'] = vm.selectBioData.DS_stable;
      
      // 거리
      BioService.deviceInput({
        user_id: $stateParams.user_id,
        day: vm.date,
        type: 'DS',
        value: vm.bio.DS,
        stable: vm.bio.DS_max,
      }),
      // 속도
      BioService.deviceInput({
        user_id: $stateParams.user_id,
        day: vm.date,
        type: 'VL',
        value: vm.bio.VL,
        stable: vm.bio.VL_max,
      }),
      // 심박수
      BioService.deviceInput({
        user_id: $stateParams.user_id,
        day: vm.date,
        type: 'HB',
        value: vm.bio.HB,
        stable: vm.bio.HB_max,
      }),
      // 산소포화도
      BioService.deviceInput({
        user_id: $stateParams.user_id,
        day: vm.date,
        type: 'OS',
        value: vm.bio.OS,
        stable: vm.bio.OS_max,
      }),
      // 젖산분비
      BioService.deviceInput({
        user_id: $stateParams.user_id,
        day: vm.date,
        type: 'LA',
        value: vm.bio.LA,
        stable: vm.bio.LA_max,
      }),
      // 체온
      BioService.deviceInput({
        user_id: $stateParams.user_id,
        day: vm.date,
        type: 'BT',
        value: vm.bio.BT,
        stable: vm.bio.BT_max,
      })
      // 땀
      
    ]).then(function (results) {
      toastr.success('저장되었습니다.')
      dataList();
    }, function () {
      toastr.error('ERROR ')
      dataList();
    }).catch(function (e) {
      console.log('ERROR ' + e);
    });

    _.forEach(deviceItems, function(item) {
      _.forEach(deviceSuffixes, function(suffix) {
        var type = item + suffix;

        // 디바이스 데이터 저장
        $.ajax({
          url: 'http://eptsdev.codns.com:7724/manager/save_device_data',
          type: 'POST',
          data: {
            user_id: $stateParams.user_id,
            day: vm.date,
            type: type,
            value: vm.bio[type]
          },
          success: function(data) {
            console.log(data);
          },
          error: function(err) {
            console.log(err);
          }
        });
      });
    });

  }

  vm.saveCheckup = function () {

    $q.all([
      // 폐활량
      BioService.userInput({
        user_id: $stateParams.user_id,
        day: vm.date,
        type: 'LC',
        value: vm.bio.LC1,
        value2: vm.bio.LC2,
        value3: vm.bio.LC3,
      }),
      // 체성분
      BioService.userInput({
        user_id: $stateParams.user_id,
        day: vm.date,
        type: 'BC',
        value: vm.bio.BC1
      }),
      // 골격근
      BioService.userInput({
        user_id: $stateParams.user_id,
        day: vm.date,
        type: 'MS',
        value: vm.bio.MS1
      }),
      // 체수분
      BioService.userInput({
        user_id: $stateParams.user_id,
        day: vm.date,
        type: 'BR',
        value: vm.bio.BR
      }),
      // 혈압
      BioService.userInput({
        user_id: $stateParams.user_id,
        day: vm.date,
        type: 'BP',
        value: vm.bio.BP1,
        value2: vm.bio.BP2
      }),
      // 혈당
      BioService.userInput({
        user_id: $stateParams.user_id,
        day: vm.date,
        type: 'BS',
        value: vm.bio.BS1,
        value2: vm.bio.BS2
      }),
      // 소변
      BioService.userInput({
        user_id: $stateParams.user_id,
        day: vm.date,
        type: 'UR',
        value: vm.bio.UR1,
        value2: vm.bio.UR2,
        value3: vm.bio.UR3,
        value4: vm.bio.UR4
      }),
      // 혈액
      BioService.userInput({
        user_id: $stateParams.user_id,
        day: vm.date,
        type: 'BL',
        value: vm.bio.BL1,
        value2: vm.bio.BL2,
        value3: vm.bio.BL3,
        value4: vm.bio.BL4,
        value5: vm.bio.BL5,
        value6: vm.bio.BL6
      }),
      // 시력/청력
      BioService.userInput({
        user_id: $stateParams.user_id,
        day: vm.date,
        type: 'EE',
        value: vm.bio.EE1,
        value2: vm.bio.EE2,
        value3: vm.bio.EE3,
        value4: vm.bio.EE4
      }),
      // 흡연
      BioService.userInput({
        user_id: $stateParams.user_id,
        day: vm.date,
        type: 'S_SM',
        value: vm.bio.S_SM
      }),
      // 음주시기
      BioService.userInput({
        user_id: $stateParams.user_id,
        day: vm.date,
        type: 'S_LD',
        value: vm.bio.S_LD
      }),
      // 음주량
      BioService.userInput({
        user_id: $stateParams.user_id,
        day: vm.date,
        type: 'S_DA',
        value: vm.bio.S_DA
      }),
      // 혈액검사1 - 빈혈수치
      BioService.userInput({
        user_id: $stateParams.user_id,
        day: vm.date,
        type: 'S_HB',
        value: vm.bio.S_HB
      }),
      // 혈액검사2 - 철분수치
      BioService.userInput({
        user_id: $stateParams.user_id,
        day: vm.date,
        type: 'S_IR',
        value: vm.bio.S_IR
      }),
      // 독감증상
      BioService.userInput({
        user_id: $stateParams.user_id,
        day: vm.date,
        type: 'S_CS',
        value: vm.bio.S_CS
      }),
      // 부정맥
      BioService.userInput({
        user_id: $stateParams.user_id,
        day: vm.date,
        type: 'S_IP',
        value: vm.bio.S_IP
      }),
      // 심장초음파검사
      BioService.userInput({
        user_id: $stateParams.user_id,
        day: vm.date,
        type: 'S_HS',
        value: vm.bio.S_HS
      }),
      // 운동부하검사/흉통
      BioService.userInput({
        user_id: $stateParams.user_id,
        day: vm.date,
        type: 'S_MP',
        value: vm.bio.S_MP
      }),
      // 흉부X-Ray촬영/폐기능검사/호흡계질환
      BioService.userInput({
        user_id: $stateParams.user_id,
        day: vm.date,
        type: 'S_CX',
        value: vm.bio.S_CX
      }),
      // 뇌진탕/실신/뇌전증[간질발작]
      BioService.userInput({
        user_id: $stateParams.user_id,
        day: vm.date,
        type: 'S_BR',
        value: vm.bio.S_BR
      }),
      // 약물 복용
      BioService.userInput({
        user_id: $stateParams.user_id,
        day: vm.date,
        type: 'S_DR',
        value: vm.bio.S_DR
      }),
      // 가족력
      BioService.userInput({
        user_id: $stateParams.user_id,
        day: vm.date,
        type: 'S_FD',
        value: vm.bio.S_FD
      })
    ]).then(function (results) {
      toastr.success('저장되었습니다.')
      dataList();
    }, function () {
      toastr.error('ERROR ')
      dataList();
    }).catch(function (e) {
      console.log('ERROR ' + e);
    });



    // $timeout(function () {
    //   dataList();
    // }, 1000)




  }

  vm.removeUserInput = function (date) {
    date = date.replace(/\./g, '');

    $ngConfirm({
      boxWidth: '30%',
      useBootstrap: false,
      title: '삭제확인',
      content: '삭제하시겠습니까?',
      scope: $scope,
      buttons: {
        confirm: {
          text: '삭제',
          btnClass: 'btn-blue',
          action: function (scope, button) {

            $q.all([
              BioService.userInput({
                user_id: $stateParams.user_id,
                day: date,
                type: 'BW',
                remove: 'Y'
              }),

              BioService.userInput({
                user_id: $stateParams.user_id,
                day: date,
                type: 'CB',
                remove: 'Y'
              }),

              BioService.userInput({
                user_id: $stateParams.user_id,
                day: date,
                type: 'CL',
                remove: 'Y'
              }),

              BioService.userInput({
                user_id: $stateParams.user_id,
                day: date,
                type: 'WT',
                remove: 'Y'
              }),

              BioService.userInput({
                user_id: $stateParams.user_id,
                day: date,
                type: 'ST',
                remove: 'Y'
              })

            ]).then(function (results) {
              toastr.success('삭제되었습니다.')
              $state.go($state.current, { user_id: $stateParams.user_id }, { reload: true });
            }, function () {
              toastr.error('ERROR ')
              $state.go($state.current, { user_id: $stateParams.user_id }, { reload: true });
            }).catch(function (e) {
              console.log('ERROR ' + e);
            });

          }
        },
        cancel: {
          text: '취소',
          btnClass: 'btn-orange',
        },
      }
    });

  };

  vm.removeDeviceInput = function (date) {
    date = date.replace(/\./g, '');

    $ngConfirm({
      boxWidth: '30%',
      useBootstrap: false,
      title: '삭제확인',
      content: '삭제하시겠습니까?',
      scope: $scope,
      buttons: {
        confirm: {
          text: '삭제',
          btnClass: 'btn-blue',
          action: function (scope, button) {

            $q.all([
              BioService.deviceInput({
                user_id: $stateParams.user_id,
                day: date,
                type: 'DS',
                remove: 'Y'
              }),
              BioService.deviceInput({
                user_id: $stateParams.user_id,
                day: date,
                type: 'VL',
                remove: 'Y'
              }),
              BioService.deviceInput({
                user_id: $stateParams.user_id,
                day: date,
                type: 'HB',
                remove: 'Y'
              }),
              BioService.deviceInput({
                user_id: $stateParams.user_id,
                day: date,
                type: 'LA',
                remove: 'Y'
              }),
              BioService.deviceInput({
                user_id: $stateParams.user_id,
                day: date,
                type: 'OS',
                remove: 'Y'
              }),
              BioService.deviceInput({
                user_id: $stateParams.user_id,
                day: date,
                type: 'BT',
                remove: 'Y'
              }),

              BioService.userInput({
                user_id: $stateParams.user_id,
                day: date,
                type: 'LC',
                remove: 'Y'
              }),
              BioService.userInput({
                user_id: $stateParams.user_id,
                day: date,
                type: 'BC',
                remove: 'Y'
              })
              ,
              BioService.userInput({
                user_id: $stateParams.user_id,
                day: date,
                type: 'MS',
                remove: 'Y'
              }),
              BioService.userInput({
                user_id: $stateParams.user_id,
                day: date,
                type: 'BT',
                remove: 'Y'
              })
            ]).then(function (results) {
              toastr.success('삭제되었습니다.')
              $state.go($state.current, { user_id: $stateParams.user_id }, { reload: true });
            }, function () {
              toastr.error('ERROR ')
              $state.go($state.current, { user_id: $stateParams.user_id }, { reload: true });
            }).catch(function (e) {
              console.log('ERROR ' + e);
            });

          }
        },
        cancel: {
          text: '취소',
          btnClass: 'btn-orange',
        },
      }
    });

  };

  // 날짜 변경
  $scope.$watch('vm.date', function(newVal, oldVal) {
    getPlayerBio(newVal);
  });


  vm.video = {
    title: '',
    url: ''
  };

  vm.content = {
    title: '',
    subtitle: '수면',
    type: 'url',
    url: ''
  };

  var list = function () {
    var data = {
      login_id: vm.appContext.user.login_id,
    };
    DashboardService.list(data)
    .then(function (res) {
      vm.contents = res.data.lists[2].list[0].contents;
      vm.videos = res.data.lists[2].list[0].videos;
      _.forEach(vm.videos,  video => {
          if (video.url.indexOf('?v=') > -1) {
            video.image = 'https://img.youtube.com/vi/' + video.url.split('=')[1] + '/0.jpg';
          } else {
            video.image = 'https://img.youtube.com/vi/' + video.url.substring((video.url).lastIndexOf('/') + 1) + '/0.jpg';
          }
      });


    })
    .catch(function(error) {
      console.log('ERROR : ',  error);
    });
  }
  list();

  vm.set = function (type, is_video) {

    if (is_video === 'N' &&  !vm.content.subtitle) {
      toastr.error('구분을 선택해 주세요. ')
      return;
    }

    var data = {
      login_id: vm.appContext.user.login_id,
      uuid: vm.appContext.user.uuid,
      type: type,
      is_video: is_video,
      is_admin: 'N',
      title: is_video === 'Y' ? vm.video.title : vm.content.title,
      subtitle: is_video === 'Y' ? vm.video.subtitle : vm.content.subtitle,
      url: is_video === 'Y' ? vm.video.url : vm.content.url
    };

    if (!data.title) {
      toastr.error('제목을 입력하세요');
      return;
    }

    if (!data.subtitle) {
      toastr.error('구분을 선택하세요');
      return;
    }

    if (!data.url) {
      toastr.error('url을 입력하세요');
      return;
    }


    DashboardService.set(data).then(function (res) {
      list();
    }).catch(function (e) {
      console.log('ERROR ' + e);
    });
  }

  vm.recommendedVideos = [];
  
  vm.isFirstSearch = true;
  var footballArr = ['football', 'football', 'football', 'soccer', 'soccer', 'futsal']; // 검색결과가 다양하게 나오게 하기 위한 처리, football, soccer 에 가중치를 줌
  
  // 영상 구분을 선택하면 영상 추천
  $scope.$watch('vm.video.subtitle', function (newVal, oldVal) {
    var container = $('#health-recommend-results');

    if (!newVal) {
      container.html('<li style="margin:0; padding:0; height:100px; line-height:100px; text-align:center;">영상 등록에서 구분을 선택해주십시오</li>');
    } else {
      var keyword = newVal;
      if (keyword === '소모' || keyword === '섭취') {
        keyword = '칼로리 ' + keyword;
      }

      container.html('<li style="margin:0; padding:0; height:100px; line-height:100px; text-align:center;">추천 영상을 조회중입니다.</li>');
      var q = (vm.isFirstSearch ? 'football' : footballArr[Math.floor(Math.random() * footballArr.length)]) + ' health ' + newVal;
      var params = {
        q: q,
        part: 'snippet', 
        maxResults: 5,
        pageToken: 'CAoQAA' // 조회할 때마다 다른 결과가 조회되게 하기 위해 - https://developers.google.com/youtube/v3/guides/implementation/pagination
      };
      
      PlanService.getVideoRecommend(params)
        .then(function(res) {
          container.empty();
          var srchItems = res.items,
            videos = [];
          $.each(srchItems, function(index, item) {
            if  (item.id.kind === 'youtube#video') {
              videos.push({
                id: item.id.videoId,
                title: item.snippet.title,
                url: 'https://youtube.com/watch?v='  +  item.id.videoId
              });

              var vidThumburl =  item.snippet.thumbnails.default.url;                 
              var vidThumbimg = '<div style="position:absolute; top:0; left:0; width:160px; height:120px;"><img id="thumb" src="'+vidThumburl+'" alt="No  Image  Available." style="width:160px;"></div>';
              var vidTitle = '<div style="position:relative; padding-top:10px; margin-left:170px; width:calc(100% - 200px); font-size:14px;">' + item.snippet.title + '<div style="margin-top:20px; text-align:center;"><a href="#" class="play-video" style="text-decoration:none; color:#4CAF50;" data-id="' + item.id.videoId + '">[영상보기]</a> <a href="#" class="select-video" style="text-decoration:none; color:#2196F3;" data-url="https://youtube.com/watch?v=' + item.id.videoId + '" data-title="' + item.snippet.title + '">[영상선택]</a></div></div>';  

              container.append('<li style="position:relative; margin:0 0 10px 0; padding:0; min-height:120px;">' + vidThumbimg + vidTitle + '</li>');                      
            }
          });

          vm.recommendedVideos = videos;

          vm.isFirstSearch = false;
        })
        .catch(function(err) {
          console.log(err);
        });
    }
  });

  // 추천영상 보기
  $('body').off('click.selectVideo').on('click.playVideo', '.play-video', function(e) {
    e.preventDefault();

    var anchor = $(this);
    document.getElementById('recommended_video').style.display = 'block';

    $scope.$apply(function () {
      vm.recommendedVideo = _.find(vm.recommendedVideos, {
        id: anchor.data('id')
      });
    });
  });

  // 추천영상 선택
  $('body').off('click.selectVideo').on('click.selectVideo', '.select-video', function(e) {
    e.preventDefault();

    var anchor = $(this);

    $scope.$apply(function () {
      vm.video.url = anchor.data('url');
      vm.video.title = anchor.data('title');
    });

    toastr.success('영상이 선택되었습니다.');
  });

  vm.remove = function (id) {

    $ngConfirm({
      boxWidth: '30%',
      useBootstrap: false,
      title: '삭제확인',
      content: '삭제하시겠습니까?',
      scope: $scope,
      buttons: {
        confirm: {
          text: '삭제',
          btnClass: 'btn-blue',
          action: function (scope, button) {

            var data = {
              login_id: vm.appContext.user.login_id,
              uuid: vm.appContext.user.uuid,
              id: id
            };
            DashboardService.remove(data).then(function (res) {
              list();
            }).catch(function (e) {
              console.log('ERROR ' + e);
            });


          }
        },
        cancel: {
          text: '취소',
          btnClass: 'btn-orange',
          // action: function (scope, button) {
          // }
        },
      }
    });


  }

  $scope.$on('youtube.player.ready', function ($event, player) {
    $rootScope.YTPlayer = player;
  });


}

export default {
  name: 'HealthDetailCtrl',
  fn: HealthDetailCtrl
};
